export default {
    props: {
        columnMenuColumns: {
            type: Boolean,
            kComposite: 'columnMenu.columns'
        }, 
        columnMenuFilterable: {
            type: Boolean,
            kComposite: 'columnMenu.filterable'
        }, 
        columnMenuSortable: {
            type: Boolean,
            kComposite: 'columnMenu.sortable'
        }, 
        columnMenuMessagesColumns: {
            type: String,
            kComposite: 'columnMenu.messages.columns'
        }, 
        columnMenuMessagesFilter: {
            type: String,
            kComposite: 'columnMenu.messages.filter'
        }, 
        columnMenuMessagesSortAscending: {
            type: String,
            kComposite: 'columnMenu.messages.sortAscending'
        }, 
        columnMenuMessagesSortDescending: {
            type: String,
            kComposite: 'columnMenu.messages.sortDescending'
        }, 
        columnMenuMessagesSettings: {
            type: String,
            kComposite: 'columnMenu.messages.settings'
        }, 
        columnMenuMessagesDone: {
            type: String,
            kComposite: 'columnMenu.messages.done'
        }, 
        columnMenuMessagesLock: {
            type: String,
            kComposite: 'columnMenu.messages.lock'
        }, 
        columnMenuMessagesUnlock: {
            type: String,
            kComposite: 'columnMenu.messages.unlock'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/ColumnMenu.js